<template>
  <div class="container" :style="{ backgroundColor: pageColor }">
    <div class="content" v-html="data.content"></div>
  </div>
</template>
<script setup>
import { getParams } from '@/utils/url'
definePageMeta({
  layout: 'clear',
})
const { data } = await useAsyncData(async (params) => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const host = config.public.VITE_LUBAN_API_HOST
  let { luban8Cid } = route.query
  const res = await $fetch(
    `${host}/activity-server/api/v1/config/activity/common?app=kuaiying&type=contentPage&subType=${luban8Cid}`
  )

  const { data } = res.data || {}
  let content = '',
    title = ''
  if (res.status === 0) {
    if (data) {
      try {
        const pageData = JSON.parse(data)
        content = pageData.content.replace(
          /\d{1,}px/g,
          ($1) => ((parseInt($1, 10) * 100) / 750).toFixed(3) + 'vw'
        )
        document.title = pageData.title
        title = pageData.title
      } catch (err) {
        console.log(err)
      }
    } else {
      console.log('页面不存在')
    }
  }
  return {
    pageType: luban8Cid,
    content,
    title,
  }
})
useHead({
  title: data.value.title,
})
// 路由里的color含有#，服务端拿不到
const pageColor = ref('')
onMounted(() => {
  let { bgColor, luban8Cid } = getParams()
  if (!bgColor && luban8Cid !== 'viptiaokuan') {
    bgColor = '#141414'
  }
  pageColor.value = bgColor
})
</script>

<style lang="less">
body {
  background-color: #fff;
  min-width: 100vw;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
  font-weight: revert;
}
::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

* {
  box-sizing: border-box;
}
strong {
  font-weight: bold !important;
}
div {
  position: relative;
}
p {
  line-height: 1;
  min-height: 14px;
}
a {
  color: #00a2fd;
}
.content {
  margin: 0 10px;
  line-height: 1;
  color: #555;
  padding: 20px;
}
img {
  margin-left: -14px;
}
@media (min-width: 900px) {
  .content {
    padding-top: 40px;
    margin: 0 20px;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
